import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorage } from 'ngx-store';


@Injectable()
    export class TaskService{
        api: string = environment.apiUrl;
        @LocalStorage('loggedUser') loggedUser: any;
        @LocalStorage('userData') userData: any;
    
        constructor(private http: HttpClient) { }

        async getCompletedTasks(): Promise<any> {
            const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
            return await this.http
                .get(this.api + `/tasks/completed_tasks`, { headers, observe: 'response' })
                .toPromise();
        }

        async saveCompletedTask(body): Promise<any> {
            const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
            return await this.http
                .post(this.api + `/tasks/completed_tasks`, body, { headers, observe: 'response' })
                .toPromise();
        }
        
        async charlieTask(): Promise<any> {
            const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
            return await this.http
              .get(this.api +`/collected-charlie-task`, { headers, observe: 'response' })
              .toPromise();
          }
    }
